import React from 'react';
import './../App.css';

//Return Footer HTML
const Footer = () => {
    return (
        <div className="footer"> 
             
              Tropical Agro - All Rights Reserved.   
        </div>
        //  <div className="footer"> 
             
        //       Holostik India Ltd - All Rights Reserved.   
        // </div>
    )
}

export default Footer;